import { getCryptoCollectionPageBySlug } from '@/api/market';

/** @type {Map<string, Promise<unknown>>} */
const inflight = new Map();

/** @type {Map<string, unknown>} */
const cache = new Map();

function normalizePagePayload(data) {
  if (Array.isArray(data?.rows)) {
    return {
      rows: data.rows,
      total: Number(data.total ?? data.rows.length),
    };
  }
  if (Array.isArray(data?.records)) {
    return {
      rows: data.records,
      total: Number(data.total ?? data.records.length),
    };
  }
  if (Array.isArray(data)) {
    return { rows: data, total: data.length };
  }
  return { rows: [], total: 0 };
}

export function buildCryptoUpdownSlugCacheKey(query, pageSize = 20, fetchAll = false) {
  return JSON.stringify({
    collSlug: query?.collSlug ?? '',
    startTime: query?.startTime ?? 0,
    endTime: query?.endTime ?? 0,
    pageSize,
    fetchAll,
  });
}

export function clearCryptoUpdownSlugCache() {
  inflight.clear();
  cache.clear();
}

async function fetchAllPages(query, pageSize) {
  const first = normalizePagePayload(
    await getCryptoCollectionPageBySlug(query, { pageNum: 1, pageSize })
  );
  let rows = [...first.rows];
  const total = Math.max(first.total, rows.length);

  if (rows.length < total) {
    const pageCount = Math.ceil(total / pageSize);
    for (let pageNum = 2; pageNum <= pageCount; pageNum += 1) {
      const page = normalizePagePayload(
        await getCryptoCollectionPageBySlug(query, { pageNum, pageSize })
      );
      rows = rows.concat(page.rows);
      if (rows.length >= total) break;
    }
  }

  return { rows, total };
}

/**
 * cryptoPageBySlug 去重：相同 query 复用 in-flight / 缓存
 */
export async function fetchCryptoUpdownSlugPage(
  query,
  { pageSize = 20, bypassCache = false, fetchAll = false } = {}
) {
  if (!query?.collSlug) return { rows: [], total: 0 };

  const key = buildCryptoUpdownSlugCacheKey(query, pageSize, fetchAll);
  if (!bypassCache && cache.has(key)) {
    return cache.get(key);
  }
  if (!bypassCache && inflight.has(key)) {
    return inflight.get(key);
  }

  const promise = (
    fetchAll ? fetchAllPages(query, pageSize) : getCryptoCollectionPageBySlug(query, { pageSize })
  )
    .then((data) => {
      const normalized = normalizePagePayload(data);
      cache.set(key, normalized);
      inflight.delete(key);
      return normalized;
    })
    .catch((err) => {
      inflight.delete(key);
      throw err;
    });

  inflight.set(key, promise);
  return promise;
}
